export default function Autocomplete() {
    return {
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    '& .MuiInputLabel-root': {
                        height: 18
                    },
                    '& .MuiFormLabel-root': {
                        top: -2
                    },
                    //small
                    '& .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
                        paddingTop: 4,
                        paddingBottom: 4
                    },
                    '& .MuiOutlinedInput-root.MuiInputBase-sizeSmall .MuiAutocomplete-input': {
                        padding: '1px 4px 1px 6px',
                        height: 24
                    },
                    '& .MuiOutlinedInput-root.MuiInputBase-sizeSmall .MuiAutocomplete-tag': {
                        marginLeft: 2,
                        marginTop: 1,
                        marginBottom: 0,
                        marginRight: 2
                    },
                    '& .MuiOutlinedInput-root.MuiInputBase-sizeSmall .MuiChip-sizeSmall': {
                        height: 23
                    },
                    '& .MuiInputLabel-sizeSmall': {
                        top: -1
                    },
                    //medium
                    '& .MuiOutlinedInput-root': {
                        paddingTop: 5.25,
                        paddingBottom: 5.25
                    },
                    '& .MuiOutlinedInput-root .MuiAutocomplete-input': {
                        padding: '1px 4px 1px 6px',
                        height: 24
                    },
                    '& .MuiOutlinedInput-root .MuiAutocomplete-tag': {
                        marginLeft: 2,
                        marginTop: 1,
                        marginBottom: 0,
                        marginRight: 2
                    },
                    '& .MuiOutlinedInput-root .MuiChip-root': {
                        height: 23
                    },
                    '& .MuiOutlinedInput-root .MuiChip-root .MuiChip-deleteIcon': {
                        height: 18
                    }
                }
            }
        }
    };
}
